import { render, staticRenderFns } from "./c-manage-pharmacists-buttons.vue?vue&type=template&id=542c65fa&scoped=true&"
import script from "./c-manage-pharmacists-buttons.vue?vue&type=script&lang=js&"
export * from "./c-manage-pharmacists-buttons.vue?vue&type=script&lang=js&"
import style0 from "./c-manage-pharmacists-buttons.vue?vue&type=style&index=0&id=542c65fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542c65fa",
  null
  
)

export default component.exports